module.exports = '1.1.2';



//////////////////
// WEBPACK FOOTER
// (webpack)-dev-server/~/sockjs-client/lib/version.js
// module id = ./node_modules/webpack-dev-server/node_modules/sockjs-client/lib/version.js
// module chunks = 3